import React from 'react';
import GBITickSheild from '../util/logos/GBITickSheild';
import './gbi-footer.scss';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import GBIButton from '../util/buttons/components/GBIButton';
import InstaIcon from '../util/icons/components/InstaIcon';
import FacebookIcon from '../util/icons/components/FacebookIcon';
import TwitterIcon from '../util/icons/components/TwitterIcon';

const GBIFooter = ({ location }) => {
  return (
    <div id="footer" className="gbi-footer">
      <div className="buttons">
        <Link to="/for-farmers">
          <GBIButton label="for farmers"
            className="farmer-button"
            testId="farmer-button" />
        </Link>
        <Link to="/for-consumers">
          <GBIButton label="for consumers"
            className="consumer-button"
            testId="consumer-button" />
        </Link>
      </div>
      <GBITickSheild />
      <h3 className="caption">
        Connecting Farmers and Consumers
      </h3>
      <section className="social">
        <a className="icon-wrapper"
          target="_blank"
          rel="noopener noreferrer"
          href="https://instagram.com/goodbeefindex?igshid=14up2uhzmoyt8">
          <InstaIcon />
        </a>
        <a className="icon-wrapper"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/goodbeefindex/">
          <FacebookIcon />
        </a>
        <a className="icon-wrapper"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.twitter.com/GoodbeefI">
          <TwitterIcon />
        </a>
      </section>
    </div>
  );
};

GBIFooter.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};

export default GBIFooter;
